import $ from 'jquery';
import Swiper from 'swiper';
import QuickAdd from '../global/QuickAdd';
import Section from '../Section';

function get_unique_array(array) {
  var newArray = new Array();
  var handleArray = new Array();

  for (var i = 0; i < array.length; i++) {
    var handle = array[i]['handle'];
    if (handleArray.indexOf(handle) === -1) {
      newArray.push(array[i]);
      handleArray.push(handle);
    }
  }
  return newArray;
}

export default class RecentlyViewed extends Section {
  RECENTLY_VIEWED_COUNT = 10;
  RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
  PLACEHOLDER = 'PLACEHOLDER';

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$element = $(element);
    this.handle = this.element.dataset.productHandle;
    this.productUrl = this.element.dataset.productUrl;
    this.blocksArray = this.element.dataset.blocks.split(',');
    this.$content = this.$element.find('#recently-viewed-products');

    if (this.$content.hasClass('recently-viewed-loading')) {
      return;
    }

    this.$content.empty().addClass('recently-viewed-loading');

    var recentlyViewedJSON = null;

    if (this._isLocalStorageSupported()) {
      recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
    }

    var recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];

    if (this.handle) {
      var item = {
        'handle': this.handle,
      };
      recentlyViewed.unshift(item);
    }

    var uniqueArray = recentlyViewed.length ? get_unique_array(recentlyViewed) : recentlyViewed;
    if (uniqueArray.length > this.RECENTLY_VIEWED_COUNT) {
      uniqueArray = uniqueArray.slice(0, this.RECENTLY_VIEWED_COUNT);
    }

    if (this._isLocalStorageSupported()) {
      localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
    }

    if (uniqueArray.length > 1 || (uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle)) {
      this.loadProducts(uniqueArray.filter((item) => { return item.handle !== this.handle }));
    } else {
      this.$element.remove();
    }

    var self = this;
    window.addEventListener('load', (event) => {
      this.quickAddButtons = new QuickAdd(theme, element);
      setTimeout(() => {
        if(self.swiper) {
          self.swiper.resize.resizeHandler();
        }
      }, 1000);
    });
  }

  loadProducts = (recentlyViewed) => {
    let str = this.paramStr(this.blocksArray);

    var promises = recentlyViewed.map(function (rv) {
      return $.get(this.productUrl.replace(this.PLACEHOLDER, rv.handle), { blocks: str });
    }.bind(this));

    $.when.apply($, promises)
      .then(() => {
        let allOK = true;

        promises.forEach((promise) => {
          if (promise.status === 200) {
            var container = document.createElement('div');
            container.innerHTML = promise.responseText;

            this.$content.append(
              container.querySelector('.main-content .grid__item').outerHTML
            );

            this.$content.find('.grid__item').addClass('swiper-slide');
            this.orderBlocks(container.querySelector('.grid-view-item'));

          } else {
            console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
            allOK = false;
          }
        });

        if (allOK) {
          this.show();
        }
        else {
          this.hideButtons();
        }
      });
  }

  orderBlocks = (parent) => {
    if(!this.blocksArray) return;

    const clone = parent.cloneNode(true);
    parent.innerHTML = '';

    this.blocksArray.forEach((block) => {
      if (!block) return;
      const blockElement = clone.querySelector(`[data-block-type=${block}]`);
      if (blockElement) {
        parent.appendChild(blockElement);
      }
    });
  }

  hideButtons = () => {
    this.$element.find('.swiper-button--next').hide();
    this.$element.find('.swiper-button--prev').hide();
  }

  show = () => {
    const nextEl = this.element.querySelector('.swiper-button--next');
    const prevEl = this.element.querySelector('.swiper-button--prev');
    this.$element.fadeIn();
    this.swiper = new Swiper(this.element.querySelector('.swiper-container'), {
      slidesPerView: 2,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
      watchOverflow: true,
      autoHeight: true,
    });

    this.loadShopNow();
    this.badge = this.theme.addBadges(this.element, 1000);
  }

  loadShopNow = () => {
    if (this.element.dataset.quickShop === 'true') {
      // it was not added in liquid as we cannot access this section settings, we have to add it manually
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.grid-view-item'),
        (el) => {
          const title = el.querySelector('.product-grid--title');
          const imgWrapper = el.querySelector('.grid-view-item-image');
          const descWrapper = el.querySelector('.grid-view-item--desc-wrapper');

          const a = document.createElement('a');
          a.classList.add('shop-now-button');
          a.href = title.querySelector('a').href;
          a.textContent = this.theme.translations.quick_shop;
          a.addEventListener('click', this.handleShopNow);

          const wrapper = document.createElement('div');
          wrapper.appendChild(a);
          wrapper.classList.add('shop-now-wrapper');

          const desktopShopNow = wrapper;
          const mobileShopNow = /** @type {HTMLInputElement} */ (wrapper.cloneNode(true));

          desktopShopNow.classList.add('shop-now-wrapper--desktop');
          mobileShopNow.classList.add('shop-now-wrapper--mobile');

          imgWrapper.appendChild(desktopShopNow);
          descWrapper.parentNode.insertBefore(mobileShopNow, descWrapper.nextSibling);
        }
      )
    }


    if (this.element.dataset.quickAdd === 'true') {
      Array.prototype.forEach.call(
        this.element.querySelectorAll('.grid-view-item'),
        (el) => {
          const productId = Number(el.dataset.productId);
          const productAvailable = (el.dataset.productAvailable == 'true');
          const productVarSize = Number(el.dataset.productVariantsSize);
          const title = el.querySelector('.product-grid--title');
          const desc = el.querySelector('.grid-view-item--desc-wrapper');

          // Construct button for this product.
          const a = document.createElement('a');
          const wrapper = document.createElement('div');
          wrapper.classList.add('quick-add-wrapper');
          if(productVarSize == 1) wrapper.classList.add('is-singular');

          if(productVarSize > 1 && productAvailable) {
            a.classList.add('quick-add-button-variants');
            a.tabIndex = 0;
            a.href = title.querySelector('a').href;
            a.textContent = this.theme.translations.view_options;
            a.addEventListener('click', this.handleShopNow);
            wrapper.appendChild(a);
          }
          else if(productAvailable) {
            // HTML Form. Used for the 'Add to cart' button functionality.
            const form = document.createElement('form');
            form.method = 'post';
            form.action = '/cart/add';
            form.id = 'CollectionAddToCartForm';
            form.acceptCharset = 'UTF-8';
            form.classList.add('shopify-product-form');
            form.enctype = 'multipart/form-data';

            // Hidden form inputs.
            const form_type = document.createElement('input');
            form_type.type = 'hidden';
            form_type.name = 'form_type';
            form_type.value = 'product';
            form.appendChild(form_type);
            const utf_input = document.createElement('input');
            utf_input.type = 'hidden';
            utf_input.name = 'utf8';
            utf_input.value = '✓';
            form.appendChild(utf_input);
            const prod_id = document.createElement('input');
            prod_id.type = 'hidden';
            prod_id.name = 'id';
            prod_id.value = productId.toString();
            form.appendChild(prod_id);

            // Submit button.
            const btn = document.createElement('button');
            btn.classList.add('quick-add-button');
            btn.type = 'submit';
            btn.tabIndex = 0;
            btn.textContent = this.theme.translations.addToCart;
            form.appendChild(btn);

            wrapper.appendChild(form);
          }
          else {
            a.classList.add('sold-out-button');
            a.href = title.querySelector('a').href;
            a.textContent = this.theme.translations.soldOut;
            wrapper.appendChild(a);
          }

          desc.parentNode.insertBefore(wrapper, desc.nextSibling);
        }
      )
    }
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.target.href });
  }

  _isLocalStorageSupported = () => {
    try {
      return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
    } catch (e) {
      return false;
    }
  }

  paramStr = (arr) => {
    var parameters = [];
    for (var property in arr) {
      if (Object.prototype.hasOwnProperty.call(arr, property) && arr[property].length > 0) {
        parameters.push(encodeURI(arr[property]));
      }
    }

    return parameters.join(',');
  }
}
